import PropTypes from 'prop-types'
import LinkButton from 'components/LinkButton'

const Buttons = ({ appId, items, listStyle }) =>
  items.map((item, i) => (
    <LinkButton key={i} href={`/${appId}/card/${item.cardId}`} id={`\'${item.name}\` button`} outline={listStyle.alternate}>
      {item.shortName || item.name}
    </LinkButton>
  ))

Buttons.propTypes = {
  appId: PropTypes.string,
  items: PropTypes.array,
  listStyle: PropTypes.object,
}

export default Buttons
